"use client";

import { useEffect } from "react";

export default function HudsonConsoleMessage() {
  useEffect(() => {
    console.log(
      `Booking Engine ${process.env.NEXT_PUBLIC_APP_VERSION} expertly developed by the team at Hudson Software, https://hudsonltd.com/`,
    );
  }, []);

  return null;
}
